"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ElevationProvider = require("@cbhq/cds-common/context/ElevationProvider");
var _usePinBorderRadiusStyles = require("@cbhq/cds-common/hooks/usePinBorderRadiusStyles");
var _cdsUtils = require("@cbhq/cds-utils");
var _useElevationStyles = require("../hooks/useElevationStyles");
var _useOffsetStyles = require("../hooks/useOffsetStyles");
var _usePinStyles = require("../hooks/usePinStyles");
var _useResponsiveConfig = require("../hooks/useResponsiveConfig");
var _useSpacingStyles = require("../hooks/useSpacingStyles");
var backgroundColorStyles = _interopRequireWildcard(require("../styles/backgroundColor"));
var _border = require("../styles/border");
var borderColorStyles = _interopRequireWildcard(require("../styles/borderColor"));
var borderRadii = _interopRequireWildcard(require("../styles/borderRadius"));
var _overflow = require("../styles/overflow");
var _responsive = require("../styles/responsive");
var _visibility = require("../styles/visibility");
var _linaria = require("../utils/linaria");
var _getFlexStyles = require("./getFlexStyles");
const _excluded = ["as", "accessibilityLabel", "accessibilityLabelledBy", "background", "children", "display", "elevation", "overflow", "opacity", "visibility", "role", "testID", "alignContent", "alignItems", "alignSelf", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "justifyContent", "borderRadius", "bordered", "borderedTop", "borderedBottom", "borderedStart", "borderedEnd", "borderedHorizontal", "borderedVertical", "borderColor", "height", "maxHeight", "maxWidth", "minHeight", "minWidth", "width", "bottom", "left", "position", "right", "top", "zIndex", "pin", "spacing", "spacingTop", "spacingBottom", "spacingStart", "spacingEnd", "spacingVertical", "spacingHorizontal", "offset", "offsetBottom", "offsetEnd", "offsetHorizontal", "offsetStart", "offsetTop", "offsetVertical", "dangerouslySetBackground", "style", "className", "responsiveConfig"],
  _excluded2 = ["children"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const ElevationStylesContainer = ({
  elevation,
  setElevationStyles
}) => {
  const elevationStyles = (0, _useElevationStyles.useElevationStyles)(elevation);
  (0, _react.useEffect)(() => {
    if (elevationStyles !== _cdsUtils.emptyObject) {
      setElevationStyles(elevationStyles);
    }
  }, [setElevationStyles, elevationStyles]);
  return null;
};
const BoxInner = /*#__PURE__*/(0, _react.forwardRef)((props, forwardedRef) => {
  const _props$as = props.as,
    as = _props$as === void 0 ? 'div' : _props$as,
    accessibilityLabel = props.accessibilityLabel,
    accessibilityLabelledBy = props.accessibilityLabelledBy,
    background = props.background,
    children = props.children,
    _props$display = props.display,
    display = _props$display === void 0 ? 'flex' : _props$display,
    elevation = props.elevation,
    overflow = props.overflow,
    opacity = props.opacity,
    visibility = props.visibility,
    role = props.role,
    testID = props.testID,
    alignContent = props.alignContent,
    alignItems = props.alignItems,
    alignSelf = props.alignSelf,
    flexBasis = props.flexBasis,
    flexDirection = props.flexDirection,
    flexGrow = props.flexGrow,
    flexShrink = props.flexShrink,
    flexWrap = props.flexWrap,
    justifyContent = props.justifyContent,
    borderRadius = props.borderRadius,
    bordered = props.bordered,
    borderedTop = props.borderedTop,
    borderedBottom = props.borderedBottom,
    borderedStart = props.borderedStart,
    borderedEnd = props.borderedEnd,
    borderedHorizontal = props.borderedHorizontal,
    borderedVertical = props.borderedVertical,
    borderColor = props.borderColor,
    height = props.height,
    maxHeight = props.maxHeight,
    maxWidth = props.maxWidth,
    minHeight = props.minHeight,
    minWidth = props.minWidth,
    width = props.width,
    bottom = props.bottom,
    left = props.left,
    position = props.position,
    right = props.right,
    top = props.top,
    zIndex = props.zIndex,
    pin = props.pin,
    spacing = props.spacing,
    spacingTop = props.spacingTop,
    spacingBottom = props.spacingBottom,
    spacingStart = props.spacingStart,
    spacingEnd = props.spacingEnd,
    spacingVertical = props.spacingVertical,
    spacingHorizontal = props.spacingHorizontal,
    offset = props.offset,
    offsetBottom = props.offsetBottom,
    offsetEnd = props.offsetEnd,
    offsetHorizontal = props.offsetHorizontal,
    offsetStart = props.offsetStart,
    offsetTop = props.offsetTop,
    offsetVertical = props.offsetVertical,
    dangerouslySetBackground = props.dangerouslySetBackground,
    _props$style = props.style,
    style = _props$style === void 0 ? _cdsUtils.emptyObject : _props$style,
    className = props.className,
    responsiveConfig = props.responsiveConfig,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const responsiveStyleClassNames = (0, _useResponsiveConfig.useResponsiveConfig)(responsiveConfig);
  const borderRadiusStyles = (0, _usePinBorderRadiusStyles.usePinBorderRadiusStyles)(pin, borderRadius);
  const _useState = (0, _react.useState)(_cdsUtils.emptyObject),
    elevationStyles = _useState[0],
    setElevationStyles = _useState[1];
  const accessibilityProps = (0, _react.useMemo)(() => {
    const ariaLabel = accessibilityLabel ? {
      'aria-label': accessibilityLabel
    } : _cdsUtils.emptyObject;
    const ariaLabelledBy = accessibilityLabelledBy ? {
      'aria-labelledby': accessibilityLabelledBy
    } : _cdsUtils.emptyObject;
    return Object.assign({}, ariaLabel, ariaLabelledBy);
  }, [accessibilityLabel, accessibilityLabelledBy]);
  const childNodes = elevation ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ElevationStylesContainer, {
    elevation: elevation,
    setElevationStyles: setElevationStyles
  }), /*#__PURE__*/_react.default.createElement(_ElevationProvider.ElevationChildrenProvider, null, children)) : children;
  return /*#__PURE__*/(0, _react.createElement)(as, Object.assign({}, restProps, {
    'data-testid': testID,
    ref: forwardedRef,
    className: (0, _linaria.cx)((0, _getFlexStyles.getFlexStyles)({
      display,
      alignContent,
      alignItems,
      alignSelf,
      flexDirection,
      flexWrap,
      justifyContent
    }), background && backgroundColorStyles[background === true ? 'background' : background], borderColor && borderColorStyles[borderColor], overflow && _overflow.overflow[overflow], borderRadius && borderRadii[borderRadius], (0, _border.getBorderStyles)({
      elevation,
      bordered,
      borderedTop,
      borderedBottom,
      borderedStart,
      borderedEnd,
      borderedHorizontal,
      borderedVertical
    }), (0, _useSpacingStyles.useSpacingStyles)({
      spacing,
      spacingBottom,
      spacingEnd,
      spacingHorizontal,
      spacingStart,
      spacingTop,
      spacingVertical
    }), (0, _useOffsetStyles.useOffsetStyles)({
      offset,
      offsetBottom,
      offsetEnd,
      offsetHorizontal,
      offsetStart,
      offsetTop,
      offsetVertical
    }), (0, _usePinStyles.usePinStyles)(pin, position), visibility && _visibility.visibility[visibility], responsiveStyleClassNames, responsiveConfig && _responsive.responsiveClassName, className),
    role
  }, accessibilityProps, {
    style: Object.assign({}, dangerouslySetBackground ? {
      backgroundColor: dangerouslySetBackground
    } : _cdsUtils.emptyObject, {
      flexBasis,
      flexGrow,
      flexShrink,
      height,
      maxHeight,
      maxWidth,
      minHeight,
      minWidth,
      width,
      position,
      bottom,
      left,
      right,
      top,
      zIndex,
      opacity,
      borderColor
    }, borderRadiusStyles, elevationStyles, style)
  }), childNodes);
});
const Box = /*#__PURE__*/(0, _react.forwardRef)((_ref, forwardedRef) => {
  let children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const boxInner = /*#__PURE__*/_react.default.createElement(BoxInner, _extends({}, props, {
    ref: forwardedRef
  }), children);
  if (props.elevation) {
    return /*#__PURE__*/_react.default.createElement(_ElevationProvider.ElevationProvider, {
      elevation: props === null || props === void 0 ? void 0 : props.elevation
    }, boxInner);
  }
  return boxInner;
});
exports.Box = Box;
Box.displayName = 'Box';
BoxInner.displayName = 'BoxInner';